/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CriteriaQualifier } from './CriteriaQualifier';
import {
    CriteriaQualifierFromJSON,
    CriteriaQualifierFromJSONTyped,
    CriteriaQualifierToJSON,
} from './CriteriaQualifier';

/**
 * 
 * @export
 * @interface CriteriaTargetInput
 */
export interface CriteriaTargetInput {
    /**
     * 
     * @type {string}
     * @memberof CriteriaTargetInput
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CriteriaTargetInput
     */
    category_id?: string;
    /**
     * 
     * @type {string}
     * @memberof CriteriaTargetInput
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CriteriaTargetInput
     */
    description?: string;
    /**
     * 
     * @type {CriteriaQualifier}
     * @memberof CriteriaTargetInput
     */
    qualifier: CriteriaQualifier;
    /**
     * 
     * @type {boolean}
     * @memberof CriteriaTargetInput
     */
    is_medication_rule?: boolean;
}

/**
 * Check if a given object implements the CriteriaTargetInput interface.
 */
export function instanceOfCriteriaTargetInput(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "qualifier" in value;

    return isInstance;
}

export function CriteriaTargetInputFromJSON(json: any): CriteriaTargetInput {
    return CriteriaTargetInputFromJSONTyped(json, false);
}

export function CriteriaTargetInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): CriteriaTargetInput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'category_id': !exists(json, 'category_id') ? undefined : json['category_id'],
        'name': json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'qualifier': CriteriaQualifierFromJSON(json['qualifier']),
        'is_medication_rule': !exists(json, 'is_medication_rule') ? undefined : json['is_medication_rule'],
    };
}

export function CriteriaTargetInputToJSON(value?: CriteriaTargetInput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'category_id': value.category_id,
        'name': value.name,
        'description': value.description,
        'qualifier': CriteriaQualifierToJSON(value.qualifier),
        'is_medication_rule': value.is_medication_rule,
    };
}

